/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_OrganizeInputs */



/**
* | output |
* | --- |
* | "Organize" |
*
* @param {Nav_Section_OrganizeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_section_organize = /** @type {((inputs?: Nav_Section_OrganizeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_OrganizeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisieren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organiser")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("整理")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("整理")
	if (locale === "ko") return /** @type {LocalizedString} */ ("정리")
	return /** @type {LocalizedString} */ ("Organize")
});